import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../authentication/AuthProvider";
import { routes } from "../routes/routes";
import { findCurrectPermission } from "../helpers/roles-and-permissions";
import { enums } from "../enums/Enums";


export function QuestionAddGuard() {
    let location = useLocation();
    const auth = useAuth();
  
    return auth?.user &&
      findCurrectPermission(enums.UserPermissionNames.HR_AddQuestion) ? (
      <Outlet />
    ) : (
      <Navigate
        to={routes?.unAuthorized.match}
        state={{ from: location }}
        replace
      />
    );
  }

  
export function QuestionViewGuard() {
    let location = useLocation();
    const auth = useAuth();
  
    return auth?.user &&
      findCurrectPermission(enums.UserPermissionNames.HR_AddQuestion) ? (
      <Outlet />
    ) : (
      <Navigate
        to={routes?.unAuthorized.match}
        state={{ from: location }}
        replace
      />
    );
  }
  
export function QuestionGetGuard() {
    let location = useLocation();
    const auth = useAuth();
  
    return auth?.user &&
      findCurrectPermission(enums.UserPermissionNames.HR_ALLQuestion) ? (
      <Outlet />
    ) : (
      <Navigate
        to={routes?.unAuthorized.match}
        state={{ from: location }}
        replace
      />
    );
  }